import {RiaStatus, type ReportSummaryDto} from '../types'

export type OverviewKpi = {
  total: number
  new: number
  pending: number
  inProgress: number
  completed: number
  rejected: number
}

const emptyKpi: OverviewKpi = {
  total: 0,
  new: 0,
  pending: 0,
  inProgress: 0,
  completed: 0,
  rejected: 0
}

export const calculateOverviewKpi = (reports?: ReportSummaryDto[]): OverviewKpi => {
  if (!reports?.length) {
    return {...emptyKpi}
  }

  return reports.reduce(
    (acc, report) => {
      const sb = report.statusBreakdown
      acc.total += report.riaCount
      acc.new += sb[RiaStatus.New] ?? 0
      acc.pending += sb[RiaStatus.Pending] ?? 0
      acc.inProgress += sb[RiaStatus.InProgress] ?? 0
      acc.completed += sb[RiaStatus.Completed] ?? 0
      acc.rejected += sb[RiaStatus.Rejected] ?? 0
      return acc
    },
    {...emptyKpi}
  )
}
